import { SHOW_NOTIFICATION, SHOW_EXPIRED_NOTIFICATION } from '../actions/types/NotificationActionTypes';
import { AUTH_LOGOUT } from '../../../redux/actions/types/authActionTypes';

export default (state = null, action) => {
  switch (action.type) {
  case SHOW_NOTIFICATION:
  case SHOW_EXPIRED_NOTIFICATION:
    return action.payload.notification;
  case AUTH_LOGOUT:
    return null;
  default:
    return state;
  }
};
